import { Injectable, inject } from "@angular/core";
import { Resolve } from "@angular/router";
import { FileService, UrlTemplate } from "files/files.service";

@Injectable({ providedIn: "root" })
export class UrlTemplateResolver implements Resolve<UrlTemplate> {
	private fileService = inject(FileService);

	// eslint-disable-next-line @typescript-eslint/require-await -- TODO: Remove this comment and fix warnings!
	async resolve(): Promise<UrlTemplate> {
		return this.fileService.getNewUrlTemplate();
	}
}
